"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatErrorName = void 0;
function formatErrorName(name) {
    if (name.indexOf('Error') === -1) {
        return name + 'Error';
    }
    return name;
}
exports.formatErrorName = formatErrorName;
